/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
import axios from "axios";
import moment from "moment";

import config from "../../config";

const initializeClient = (baseURL) => {
  const client = axios.create({
    baseURL,
    headers: {
      "X-Timezone-Offset": -moment().zone(),
    },
  });

  client.interceptors.request.use((config) => addAuthHeaders(config, client));
  return client;
};

const addAuthHeaders = (config, client) => {
  const token = localStorage.getItem("token");

  if (config.baseURL === "https://ifsc.razorpay.com") {
    delete client.defaults.headers.common.Authorization;
  }

  if (token) {
    config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
  }

  return config;
};

const createRequestHandler = (client) => {
  return async (options) => {
    try {
      const response = await client({ ...options });
      return response.data;
    } catch (error) {
      return handleRequestError(error);
    }
  };
};

const handleRequestError = (error) => {
  console.error("Request Failed:", error?.config);

  // If it's a cancellation error, preserve it as-is
  if (axios.isCancel(error)) {
    throw error;
  }

  if (error.response) {
    console.error("Status:", error.response.status);
    console.error("Data:", error.response.data);
    console.error("Headers:", error.response.headers);
  } else {
    console.error("Error Message:", error.message);
  }

  const errorMessage =
    error.response?.data?.result?.message ||
    error.response?.data?.result ||
    error.message;
  const errorObject = new Error(errorMessage);
  errorObject.response = error.response;
  errorObject.status = error.response?.status;
  errorObject.data = error.response?.data;
  throw errorObject;
};

const searchRequestHandler = async (url, options) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${config.baseApiUrl}${url}`, {
    ...options,
    headers: { Authorization: `Bearer ${token}` },
  });
  let resp;
  if (data?.headers.get("content-type").includes("text/csv")) {
    resp = await data.blob();
  } else {
    resp = await data.json();
  }
  return resp;
};

// Initialize clients (APIs instances)
export const API = initializeClient(config.baseApiUrl);
export const CORE_API = initializeClient(`${config.baseApiUrl}/api/v1`);

// Export request handlers
export const request = (options) => {
  return createRequestHandler(API)(options);
};
export const coreAPIrequest = (options) =>
  createRequestHandler(CORE_API)(options);

export const searchRequest = (url, options) =>
  searchRequestHandler(url, options);
